import React from 'react'
import { Link } from 'react-router-dom'

const Copyright = () => {
  return (
    <>
      <footer className='bg-dark text-light pt-3'>
      <div className='d-flex justify-content-between px-lg-5 px-3'>
          <p>Copyright &copy; Omanshi Travels. All Rights Reserved.</p>
          <p>Developed By <Link className='footer-link' to='https://dectwinservices.com'>Dectwin Services Pvt Ltd</Link></p>
        </div>
      </footer>
    </>
  )
}

export default Copyright
